import { defineStore } from "pinia";
import { Store } from "@/common/stores.enum";
import { RecaptchaStoreState } from "@/domain/search/entitites/recaptcha-store-state.interface";
import {
    AnalyticsEcommerceEvent,
    AnalyticsStorage,
    FbqUtil,
    GTMUtils, TicketItem,
    Url
} from "webshop-modules";
import VueRecaptcha from "vue3-recaptcha2";
import { CheckoutData } from 'webshop-modules/google-tag-manager/entity/base/CheckoutData.interface';

export const useRecaptchaStore = defineStore(Store.Recaptcha, {

    state: (): RecaptchaStoreState => ({
        queuedSubmit: null,
        required: false,
        recaptchaInstance: null,
        displayed: false,
        ecommerceEvent: null,
    }),

    actions: {
        instance() {
            return this.recaptchaInstance;
        },
        initialize(instance: typeof VueRecaptcha) {
            this.recaptchaInstance = instance;
        },
        queue(url: string) {
            this.queuedSubmit = url;
        },
        clearQueue() {
            this.queuedSubmit = null;
            this.ecommerceEvent = null;
        },
        queueSubmit(url: string, ecommerce: AnalyticsEcommerceEvent<CheckoutData<TicketItem>>) {
            this.ecommerceEvent = ecommerce;
            return this.queue(url);
        },
        isRequired(): boolean {
            return this.required;
        },
        isDisplayed(): boolean {
            return this.displayed;
        },
        setRequired(required: boolean) {
            this.required = required;
        },
        setDisplayed(displayed: boolean) {
            this.displayed = displayed;
        },
        handleExpiredEvent() {
            this.reset();
        },
        reset() {
            this.clearQueue();
            this.recaptchaInstance.reset();
        },
        async handleVerifiedEvent(token: string) {
            const url: string = this.queuedSubmit as string;
            const eventId = Number.parseInt(new Url(url).getSearchParam('eventId')!);
            const ecommerceEvent = this.ecommerceEvent as AnalyticsEcommerceEvent<CheckoutData<TicketItem>> ?? null;

            this.reset();

            const analyticsStore = AnalyticsStorage.getInstance();

            FbqUtil.fbqEvent('AddToCart',[`${eventId}`], 'product');

            if (ecommerceEvent) {
                GTMUtils.pushGA4EcommerceToDataLayer(ecommerceEvent);

                if (analyticsStore) {
                    analyticsStore.updateLocalStore({ currency: ecommerceEvent.ecommerce.currency });
                    analyticsStore.pushCartItems(ecommerceEvent.ecommerce.items);
                }
            }

            window.location.assign(url + '&g-recaptcha-response=' + token);
        },
    }
})
